import React, { useContext, useMemo, useEffect, useState } from 'react';
import result from 'lodash/result';
import isEqual from 'lodash/isEqual';
import { usePrevious } from '../../lib/usePrevious';
import { FormContext } from './FormContext';
const defaultProps = {
    resetOnUnmount: true
};
export const FormField = props => {
    const opts = Object.assign({}, defaultProps, props);
    const { children, path, validateOnBlur, validations, resetOnUnmount, calculateValue } = opts;
    const { store } = useContext(FormContext);
    const [changed, setChanged] = useState(false);
    const field = store.getField(path) ||
        store.addField({ path, validateOnBlur, validations });
    const prevField = store.getPreviousField(path);
    //const formErrors = state.errors;
    const value = result(store.state.values, path);
    const prevValue = result(store.prevState ? store.prevState.values : {}, path);
    // console.log("get foem field");
    let calculatedValue = useMemo(() => calculateValue && !changed
        ? calculateValue(store.state.values, path, store)
        : undefined, [store.state.values, changed]);
    useEffect(() => {
        if (calculateValue && value !== calculatedValue && !changed) {
            store.change(field.path, calculatedValue);
        }
    }, [calculatedValue, value, changed]);
    const handleBlur = (path) => {
        const field = store.getField(path);
        store.changeFieldMeta(path, { touched: true });
        if (field.validateOnBlur)
            store.validateField(path);
    };
    const handleFocus = (path) => { };
    const child = useMemo(() => {
        if (!field)
            return null;
        return children({
            field,
            input: {
                value,
                onChange: value => {
                    setChanged(true);
                    store.change(field.path, value);
                },
                onBlur: () => handleBlur(field.path),
                onFocus: () => handleFocus(field.path)
            },
            form: store
        });
    }, [
        value,
        isEqual(value, prevValue),
        isEqual(field, prevField),
        field.meta.errors.length
    ]);
    const prevPath = usePrevious(path);
    useEffect(() => {
        store.updateField(prevPath, { path });
    }, [path]);
    useEffect(() => {
        return () => {
            store.removeField(path, resetOnUnmount);
        };
    }, []);
    return React.createElement(React.Fragment, null, child);
};
//# sourceMappingURL=FormField.js.map